<template>
  <div class="flex flex-col items-center gap-1">
    <div
      class="h-12 w-10 flex flex-col items-center justify-center shrink-0 bg-gray-300 outline outline-[3px] outline-[#FDFDFE] rounded-sm"
      :class="{ 'bg-center bg-cover bg-no-repeat cursor-pointer': loaded }"
      :style="`background-image: url(${url})`"
    >
      <LoadingSpinner v-show="!loaded" size="xs" />
    </div>
    <div
      v-if="remove"
      v-show="loaded"
      class="flex flex-col items-center justify-center"
      @click.stop
    >
      <Component
        :is="confirm ? DeleteModal : 'div'"
        :title="$t('components.details.images.delete.confirm.title')"
        :description="
          $t('components.details.images.delete.confirm.description')
        "
        class="hover:cursor-pointer"
        @click="!confirm && $emit('remove')"
        @delete="$emit('remove')"
      >
        <IconButton variant="secondary" type="filled" size="2xs">
          <Icon name="minus" aria-hidden="true" size="full" />
        </IconButton>
      </Component>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { IconButton } from "@/SharedComponents/Buttons";
import { LoadingSpinner } from "@/SharedComponents/LoadingSpinner";
import { DeleteModal } from "@/SharedComponents/Modals";
import { Icon } from "@/SharedComponents/Icon";

defineEmits(["remove"]);

const props = defineProps({
  url: { type: String, required: true },
  remove: { type: Boolean, required: false },
  confirm: { type: Boolean, required: false },
});

const loaded = ref(false);

onMounted(() => {
  var image = new Image();
  image.onload = function () {
    loaded.value = true;
  };
  image.src = props.url;
});
</script>
